import { render, staticRenderFns } from "./StatusDetector.vue?vue&type=template&id=6b48e52c&scoped=true&"
import script from "./StatusDetector.vue?vue&type=script&lang=js&"
export * from "./StatusDetector.vue?vue&type=script&lang=js&"
import style0 from "./StatusDetector.vue?vue&type=style&index=0&id=6b48e52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48e52c",
  null
  
)

export default component.exports